import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix

/**
 * Class representing the FilterAgentListView.
 * @extends JetView
 */
export default class FilterAgentListView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the filter form
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for User ID
                    name: 'Id',
                    type: 'number',
                    label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // Localized label
                    hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-filterByUser',
                    labelPosition: 'top',
                    placeholder: _('ID Usuario'), // Placeholder text
                },
                {
                    view: 'text', // Text input for date selection
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true, // Read-only input
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        // Center left section of the filter form
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for user email
                    name: 'Login',
                    label: "<span class='icon-mail'></span>" + _('Usuario (Correo electrónico)'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Usuario (Correo electrónico)'), // Placeholder text
                },
            ],
        };

        // Center right section of the filter form
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Dropdown for registration status
                    name: 'IsRegisterActivate',
                    label: "<span class='icon-state'></span>" + _('Estado de Registro'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    value: '',
                    options: [
                        // Options for the dropdown
                        { id: '', value: _('Todos') },
                        { id: 'A', value: _('Activo') },
                        { id: 'I', value: _('Inactivo') },
                        { id: 'R', value: _('Rechazado') },
                    ],
                },
            ],
        };

        // Right section of the filter form
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Dropdown for general status
                    name: 'IsActivate',
                    label: "<span class='icon-state'></span>" + _('Estado'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    value: '',
                    options: [
                        // Options for the dropdown
                        { id: '', value: _('Ambos') },
                        { id: 'A', value: _('Activo') },
                        { id: 'I', value: _('Inactivo') },
                    ],
                },
            ],
        };

        // Upper section containing the filter inputs
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right], // Layout of the filter inputs
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 5,
            cols: [
                {},
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'), // Localized button text
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form inputs
                    },
                },
                {
                    view: 'button', // Button to submit the filter
                    value: _('Consultar'), // Localized button text
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get values from the form
                        this.app.callEvent('playersList:filter', [filterdata]); // Trigger filter event with data
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons], // Combine upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the form
            },
        };
    }
}

// FILE DOCUMENTED
